import { render, staticRenderFns } from "./InputClient.vue?vue&type=template&id=ad3c97a2"
import script from "./InputClient.vue?vue&type=script&lang=js"
export * from "./InputClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports